import { IntentType } from '@40seas/entities/intents';

export const GUEST_PORTAL_INTENTS = [IntentType.GuestBuyerLink, IntentType.GuestCreditLineLink];
